import React from 'react';
import { withInjectedProps } from '../../../../Core/InjectedPropsContext';
import { ListFieldSection } from '../../../../Layout';
import { Field, NumericInput, TextInput, TextOutput } from '../../../../Core';
import { IWorksheetComponent } from 'Components/Worksheets/Core/types';
import { DryMassesDetermination } from '../../types';

interface MaterialMassesSectionProps extends IWorksheetComponent {
  dryMassesDetermination?: DryMassesDetermination;
  heading?: string;
}

let MaterialMassesSection: React.FC<MaterialMassesSectionProps> = ({ dryMassesDetermination, heading }) => (
  <ListFieldSection heading={heading}>
    {dryMassesDetermination === 'direct_drying' && (
      <Field input={<TextInput />} name="TareId" label="Tare ID" maxLength={20} />
    )}
    <Field input={<NumericInput />} label="Tare Mass" name="TareMass" />
    {dryMassesDetermination !== 'already_dry' && (
      <>
        <Field input={<NumericInput />} label="Tare and Material Wet Mass" name="WetSoilAndTareMass" />
        <Field input={<TextOutput />} label="Material Wet Mass" name="WetSoilMass" />
      </>
    )}
    {dryMassesDetermination !== 'coarse_fine_moisture_content' && (
      <Field input={<NumericInput />} label="Tare and Material Dry Mass" name="DrySoilAndTareMass" />
    )}
    <Field input={<TextOutput />} label="Material Dry Mass" name="DrySoilMass" />
  </ListFieldSection>
);

MaterialMassesSection = withInjectedProps(MaterialMassesSection);

export { MaterialMassesSection };
export default MaterialMassesSection;
